new MutationObserver(() => {
    const popmechanicImage = document.querySelector('popmechanic-image')
    if (popmechanicImage) {
        popmechanicImage.removeAttribute('role')
        popmechanicImage.removeAttribute('aria-label')
    }
    const cards = document.querySelectorAll('.popmechanic-item-card');
    if (cards && cards.length > 0) {
        cards.forEach(el => {
            if (el.getAttribute('aria-hidden') === 'true') {
                el.querySelectorAll('a').forEach((child) => {
                    child.setAttribute('tabindex', '-1');
                });
            }
        });
    }
}).observe(document.body, { childList: true, subtree: true });

document.querySelector('popmechanic-image').forEach(el => {
    el.removeAttribute('role')
    el.removeAttribute('aria-label')
})

document.querySelectorAll('.popmechanic-item-card').forEach(el => {
    if (el.getAttribute('aria-hidden') === 'true') {
        el.querySelectorAll('a').forEach((child) => {
            child.setAttribute('tabindex', -1)
        })
    }
})
